import { ErrorResponseNode } from './error.response.node';

export class ErrorResponse {
    errors: ErrorResponseNode[];
}
